import AuthActions from "./auth";
import TaskActions from "./task";
import UserActions from "./user";
import SheetActions from "./sheet";
import AppActions from "./app";
import CompanyActions from "./company";
import ProjectActions from "./project";
import projectCreateActions from "./projectCreate";

export default {
  ...AuthActions,
  ...UserActions,
  ...CompanyActions,
  ...SheetActions,
  ...AppActions,
  ...ProjectActions,
  ...TaskActions,
  ...projectCreateActions
};
